import { StateCreator } from 'zustand'
import { OrgType } from 'app/dataTypes/org/types'
import { FilterValues, AppliedSlice, FilterStore } from './types'
import { calcDefaultPeriod } from './defaultPeriod'

const emptyApplied: FilterValues = {
  orgType: OrgType.School,
  orgIds: undefined,
  buildingIds: undefined,
  schoolYearId: undefined,
  period: calcDefaultPeriod(),
  saleTypeIds: undefined,
  foodModeIds: undefined,
  customerTypeIds: undefined,
  salePointIds: undefined,
  employeeIds: undefined,
  mail: 'do_not_mail',
  // ADD HERE
}

export const createAppliedSlice: StateCreator<FilterStore, [], [], AppliedSlice> = (set, get) => ({
  applied: emptyApplied,

  applyDraft() {
    set({
      applied: {
        ...get().draft,
      },
    })
  },

  applyDefaults() {
    set({
      applied: {
        ...get().defaults,
      },
    })
  },

  applyDefaultsByKey(key: keyof FilterValues) {
    set({
      applied: {
        ...get().applied,
        [key]: get().defaults[key],
      },
    })
  },
})
